var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('file-page',{attrs:{"allowDownload":_vm.allowDownload,"fileType":"FATURAS_DISTRIBUIDORAS","pageTitle":"Faturas","columnList":_vm.columnList,"selectVal":_vm.selectVal}})}
var staticRenderFns = []

export { render, staticRenderFns }